import { Environment, defines, ItemManager, Cameras } from "./index";
import * as THREE from "three";
import { VertexNormalsHelper } from 'three/examples/jsm/helpers/VertexNormalsHelper.js';

/* Scene
 * 3Dシーンデータ.
 */
export class Scene {

    _instance: THREE.Scene;
    public get me(): THREE.Scene { return this._instance; }
    public set me(i: THREE.Scene) { this._instance = i; }

    private _environment: Environment;
    public get environment(): Environment { return this._environment; }

    private _wireframes: THREE.LineSegments[];
    private _vertexNormals: VertexNormalsHelper[];

    constructor() {
        // シーン (空間) を作成.
        this.me = new THREE.Scene();

        // 環境の作成
        this._environment = this.createEnvironment();
        this._environment.apply(this);
    }

    public createEnvironment(): Environment {
        return new Environment;
    }
    public add(obj: THREE.Object3D) {
        this.me.add(obj);
    }
    public remove(obj: THREE.Object3D) {
        this.me.remove(obj);
    }
    public load(scene_data: THREE.Scene) {
        this.me = scene_data;
    }
    public reset(options: defines.Options) {
        let reset_env: boolean = options.is(defines.ResetOptions.resetEnv, true);
        this.removeWireframes();
        if (reset_env) this._environment.reset(this);
    }
    public update(items: ItemManager, cameras: Cameras, timeStamp: number) {
        /* do nothing */
    }

    /*
     * ワイヤフレーム表示.
     */
    protected removeWireframes() {
        if (this._wireframes != undefined) {
            for (let i = 0; i < this._wireframes.length; i++)
                this.me.remove(this._wireframes[i]);
            this._wireframes = undefined;
        }
    }

    public addWireframe(wfh: THREE.LineSegments): void {
        if (this._wireframes == undefined)
            this._wireframes = [];
        this._wireframes.push(wfh);
        this.me.add(wfh);
    }

    public get wireframe(): boolean {
        return (this._wireframes != undefined);
    }
    public set wireframe(value: boolean) {
        if (value) {
            if (!this.wireframe) {
                this._wireframes = [];
                let scope = this._wireframes;
                let scene = this.me;
                this.me.traverse(function (child) {
                    const mesh: THREE.Mesh = <THREE.Mesh>(child);
                    if (mesh.isMesh) {
                        const wireframe = new THREE.WireframeGeometry(mesh.geometry);
                        const line = new THREE.LineSegments(wireframe, new THREE.LineBasicMaterial({ color: 0x00ff00 }));
                        (line.material as THREE.Material).opacity = 0.1;
                        (line.material as THREE.Material).transparent = true;

                        let position = new THREE.Vector3();
                        let quaternion = new THREE.Quaternion();
                        let scale = new THREE.Vector3();

                        mesh.matrixWorld.decompose(position, quaternion, scale);
                        line.position.add(position);
                        line.quaternion.copy(quaternion);
                        line.scale.copy(scale);
                        scope.push(line);
                        scene.add(line);
                    }
                });
            }
        }
        else {
            this.removeWireframes();
        }
    }
}
